import { render, staticRenderFns } from "./BaseTabs2.vue?vue&type=template&id=1a245560&scoped=true&lang=pug&"
import script from "./BaseTabs2.vue?vue&type=script&lang=js&"
export * from "./BaseTabs2.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabs2.vue?vue&type=style&index=0&id=1a245560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a245560",
  null
  
)

export default component.exports